export default __webpack_public_path__ + "static/media/Logo1.4265da93.png";